import ApplicationController from './application_controller';

// Tiny copy-to-clipboard controller. Wire it up on a container that holds:
//   - a "source" target whose textContent is what gets copied
//   - an "icon" target inside the trigger button; we briefly swap its class
//     to bi-clipboard-check on success so the user gets visual feedback
//
// Example:
//   <div data-controller="clipboard">
//     <button data-action="clipboard#copy" type="button">
//       <i class="bi bi-clipboard" data-clipboard-target="icon"></i>
//     </button>
//     <pre data-clipboard-target="source">{...}</pre>
//   </div>
export default class extends ApplicationController {
  static targets = ['source', 'icon'];

  async copy(event) {
    event.preventDefault();
    if (!this.hasSourceTarget) return;
    const text = this.sourceTarget.textContent;
    try {
      await navigator.clipboard.writeText(text);
      this.flashSuccess();
    } catch (_) {
      // Older browsers / non-secure contexts: fall back to the deprecated
      // execCommand path. Best-effort — if both fail there's nothing useful
      // to show.
      this.legacyCopy(text);
    }
  }

  flashSuccess() {
    if (!this.hasIconTarget) return;
    const icon = this.iconTarget;
    icon.classList.remove('bi-clipboard');
    icon.classList.add('bi-clipboard-check', 'text-success');
    setTimeout(() => {
      icon.classList.remove('bi-clipboard-check', 'text-success');
      icon.classList.add('bi-clipboard');
    }, 1200);
  }

  legacyCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      this.flashSuccess();
    } catch (_) {
      // give up silently
    } finally {
      document.body.removeChild(ta);
    }
  }
}
